import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import ListResource from '../../lists/ListResource.jsx';
import { env } from '../../../config';

const api = '/api/core/teacherReports';

const PageTeacherReport = () => {
  const [filter] = useState({});
  const { i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';
  // Only include primary school grades (小一 .. 小六) in this report
  const gradeOptions = Object.keys(env.grades)
    .filter((g) => {
      const n = Number(g);
      return !Number.isNaN(n) && n >= 1 && n <= 6;
    })
    .sort((a, b) => Number(a) - Number(b))
    .map((g) => ({ value: g, label: env.grades[g][lang] }));

  return (
    <div>
      <h2>老師報告</h2>
      <ListResource
        api={api}
        filter={filter}
        sort={{ 'name.full.en': 1 }}
        actions={{
          fileExport: true,
          find: false,
          create: false,
          remove: false,
        }}
         searchable={[
           { value: 'name', label: 'Name' },
           { value: 'schoolClass.title', label: 'Class' },
           // group label dropdown (初小組 / 高小組) - uses a distinct search key
           {
             value: 'schoolClass.grade',
             label: '組別',
             options: [
               { value: 'junior', label: '初小組' },
               { value: 'senior', label: '高小組' },
             ],
           },
           // numeric grade dropdown (use env.grades like ListRankings)
          //  {
          //    value: 'schoolClass.grade',
          //    label: '年級',
          //    options: gradeOptions,
          //  },
         ]}
        cols={[
          { key: 'name.full.zhhk', children: '學生名稱' },
          { key: 'email', children: '帳戶名稱' },
          {
            // derived label column - reads numeric grade from row.grade and shows localized label
            key: 'gradeLabel',
            children: '組別',
            getter: (v, r) => {
              const g = r && r.grade;
              if (g === undefined || g === null) return '';
              const gn = Number(g);
              if (!Number.isNaN(gn)) {
                if (gn >= 1 && gn <= 3) return '初小組';
                if (gn >= 4 && gn <= 6) return '高小組';
              }
              return g;
            },
          },
          {
            // show localized grade label (e.g. 小一, 小二) instead of raw number
            key: 'grade',
            children: '年級',
            getter: (v, r) => {
              const g = (r && r.grade) || '';
              if (g === '' || g === undefined || g === null) return '';
              // env.grades keys are strings; prefer env label if available
              const key = String(g);
              return env.grades[key] ? env.grades[key][lang] : g;
            },
          },
          { key: 'schoolClassTitle', children: '班別' },
          { key: 'stage1Completed', children: '階段1完成', getter: (v) => `${v || 0} / 10` },
          { key: 'stage2Completed', children: '階段2完成', getter: (v) => `${v || 0} / 10` },
          { key: 'stage3Completed', children: '階段3完成', getter: (v) => `${v || 0} / 10` },
          { key: 'totalCompleted', children: '總共完成', getter: (v) => v || 0 },
        ]}
      />
    </div>
  );
};

export default PageTeacherReport;
